import {useEffect, useState, useMemo} from "react";
import CircularProgress from "@mui/material/CircularProgress";
import {useParams} from "react-router-dom";
import SecureImage from "./secureimage"; // Import the secure rendering canvas layer


export default function IMGViewer({files, isusingparams, initialPage }) {
  // const {category} = useParams();
  
  const activePages = useMemo(() => {
    return files || [];
    }, [files]);

  return (
    <div 
      id="img-viewer" 
      style={{
        userSelect: "none",
        WebkitUserSelect: "none",
        width: "100%",
        maxWidth: "1280px", // Keeps layout bounds constrained on massive view screens
        margin: "2rem auto"}}>
          {activePages.length > 0 ? (
          <div 
            style={{
              width: "100%",
              backgroundColor: "#f5f5f5",
              borderRadius: "12px",
              padding: "16px",
              boxSizing: "border-box"}}>
            {/* Dynamically renders only the pages belonging to the active parameter mapping */}
            {activePages.map((pageSrc, index) => (
              <SecureImage key={index} imageSrc={pageSrc}/>
            ))}
          </div>) : <CircularProgress/>}
      </div> 
  );
}